import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=0035afc4&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&lang=js"
export * from "./SubmitForm.vue?vue&type=script&lang=js"
import style0 from "./SubmitForm.vue?vue&type=style&index=0&id=0035afc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035afc4",
  null
  
)

export default component.exports